import { render, staticRenderFns } from "./GanttRouting.vue?vue&type=template&id=2c591bf4&"
import script from "./GanttRouting.vue?vue&type=script&lang=js&"
export * from "./GanttRouting.vue?vue&type=script&lang=js&"
import style0 from "./GanttRouting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports